import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import * as Icon from 'react-feather'
import { uploadAction, resetUploadAction } from 'redux/actions/fileUploadActions'
import FileDropZone from 'components/common/FileDropZone'
import clsx from 'clsx'
import { Button } from '@material-ui/core/'
import SecureImage from 'components/common/SecureImage';


class LogoUploadModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logo: '',
      response: null,
      loading: false,
      progress: null,
      errors: null,
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.onFileDrop = this.onFileDrop.bind(this)
  }

  onFileDrop = acceptedFiles => {
    this.setState({ logo: acceptedFiles[0] })
  }

  onSubmit(event) {
    event.preventDefault()
    const formData = new FormData()
    formData.append('logo', this.state.logo)
    this.props.uploadAction(formData)
  }

  static getDerivedStateFromProps(nextProps) {
    let { response, loading, progress, errors } = nextProps
    return { response, loading, progress, errors }
  }

  render() {
    const { response, loading, progress, errors, logo } = this.state
    const { classes } = this.props
    return (
      <div>
        <button type="button" className={`c-btn ${classes.buttonPrimary}`} data-toggle="modal" data-target="#modal2">
          <i className="feather icon-upload"></i> Upload Logo
        </button>

        <div className="c-modal modal fade" id="modal2" tabIndex="-1" role="dialog" aria-labelledby="modal2">
          <div className="c-modal__dialog modal-dialog" role="document">
            <div className="c-modal__content">
              <div className="c-modal__body">
                <span className="c-modal__close" data-dismiss="modal" aria-label="Close">
                  <i className="feather icon-x"></i>
                </span>

                <span className="c-icon c-icon--large u-mb-small">
                  <i className="feather icon-upload"></i>
                </span>

                {!response && (
                  <>
                    <h3 className="u-mb-small">Upload File</h3>

                    <div className="u-mb-medium">
                      <FileDropZone
                        onDrop={acceptedFiles => this.onFileDrop(acceptedFiles)}
                        multiple={false}
                        icon={<Icon.Image size={50} className="cv u-color-primary"></Icon.Image>}
                        disabled={false}
                        accept={'image/*'}
                        maxSize={1048576 * 512}
                        label={
                          'Drag and drop your cover image file here, or click to select file  *.jpg, *.jpeg or *.png  250 x 70 px recommended'
                        }
                      />
                    </div>
                  </>
                )}

                {!errors && progress && !response && (
                  <div className={'u-m-medium'}>
                    <h3 className="u-mb-small">{`Uploading file ${progress}% complete`}</h3>
                  </div>
                )}

                {!errors && response && !loading && (
                  <>
                    <h3 className="u-mb-small">Uploaded File</h3>
                    <div className={'u-m-medium'}>
                      <SecureImage alt="uploaded " source={`/api/uploads/${response}`} />
                    </div>
                  </>
                )}

                {errors?.flash && (
                  <div className="u-m-medium">
                    <h6 className="u-mb-small"> {errors?.flash}</h6>
                  </div>
                )}

                <div className="o-line">
                  <span className={`c-btn ${classes.buttonSecondary}`} data-dismiss="modal" aria-label="Close">
                    Cancel
                  </span>
                  {!errors && response && (
                    <button
                      onClick={() => {
                        this.props.setLogo(response)
                        this.props.resetUploadAction()
                      }}
                      className={`c-btn ${classes.buttonPrimary}`}
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <i className="feather icon-plus"></i> Insert
                    </button>
                  )}

                  {!response && (
                    <Button
                      disabled={isEmpty(logo)}
                      type="submit"
                      onClick={this.onSubmit}
                      className={clsx('c-btn', classes.buttonPrimary)}
                    >
                      <i className="feather icon-upload"></i> Upload
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

LogoUploadModal.propTypes = {
  setLogo: PropTypes.func,
  resetUploadAction: PropTypes.func,
  uploadAction: PropTypes.func,
  upload: PropTypes.object,
  classes: PropTypes.object,
  loading: PropTypes.bool,
  progress: PropTypes.number,
  errors: PropTypes.array,
  response: PropTypes.object,
}

const mapStateToProps = state => ({
  upload: state.upload,
  response: state.upload.response,
  loading: state.upload.loading,
  progress: state.upload.progress,
  errors: state.upload.errors,
})

export default connect(mapStateToProps, { uploadAction, resetUploadAction })(LogoUploadModal)
